import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";

const Onboarding = () => {
  const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
  const sourceDivRef = useRef(null); // Ref for the source div
  const [errors, setErrors] = useState("0");
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");
  const [joiningData, setJoiningData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    // handleSelectChange();
    getMonthYearOptions();
  }, []);

  const handleSelectChange = (name, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    const selectedValue = selectedOption ? selectedOption.value : "";

    if (name === "month_year") {
      if (selectedValue !== selectedMonthYear) {
        setSelectedMonthYear(selectedValue);
        console.log("Month-Year changed to:", selectedValue);
        getAppointmentLetter(selectedValue, selectedOfferStatus);
        getOfferLetter(selectedValue, selectedOfferStatus);
        getJoinCountMonthWise(selectedValue, selectedOfferStatus);
        setSelectedMonthYear(selectedOption?.value || null);
      }
    } else if (name === "offer_status") {
      if (selectedValue !== selectedOfferStatus) {
        setSelectedOfferStatus(selectedValue);
        console.log("Offer Status changed to:", selectedValue);
        getOfferLetter(selectedMonthYear, selectedValue);
        getAppointmentLetter(selectedMonthYear, selectedValue);
      }
    }
  };
  const offerStatusOptions = [
    { value: "0", label: "Sent" },
    { value: "1", label: "Viewed" },
    { value: "2", label: "Accepted" },
    { value: "3", label: "Rejected" },
    { value: "4", label: "Cancelled" },
    { value: "5", label: "Expired" },
  ];
  const chartData = chartOptions?.series || [0, 0, 0, 0, 0, 0];

  const getLabelFromValue = (value) => {
    const status = offerStatusOptions.find((option) => option.value === value);
    return status ? status.label : "Unknown Status";
  };

  // const getofferLetter = (event, status) => {
  //     const selectMonthOffer = event;
  //     const selectedOfferStatus = status;

  //     setselectMonthAppointment(selectMonthOffer);

  //     const headers = apiHeaderJSON;

  //     if (selectMonthOffer) {
  //       console.log(
  //         "Fetching offer letter count for month-year:",
  //         selectMonthOffer
  //       );

  //       axios
  //         .get(`${apiURL}DashboardRouter/GetOfferLetterSentCount`, {
  //           params: {
  //             request_month_year: selectMonthOffer,
  //             offer_status: selectedOfferStatus,
  //           },
  //           headers,
  //         })
  //         .then((response) => {
  //           console.log("OfferLetterCount Response:", response);

  //           const data = response.data;
  //   let offerCount = data.offer_letter_count;
  //           if (data.success) {
  //             console.log("Offer Letter Count:", data.offer_letter_count);
  //             setOfferLetterCount(data.offer_letter_count);
  //           }
  //           setChartOptions({
  //             labels: offerStatusOptions || [], // Labels for the donut slices
  //             series: offerCount || [],
  //           });

  //           else {
  //             console.error(
  //               "Failed to fetch offer letter count. Message:",
  //               data.message || "No additional error message provided by server."
  //             );
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("Error fetching offer letter count:", error.message || error);
  //         });
  //     } else {
  //       console.warn("No month-year selected. Skipping offer letter fetch.");
  //     }
  //   };

  const getOfferLetter = async (event, status) => {
    const selectMonthOffer = event;
    const selectedOfferStatus = status;

    // Set loading state (if you have a loading state in your application)

    try {
      if (!selectMonthOffer) {
        console.warn("No month-year selected. Skipping offer letter fetch.");
        return;
      }

      console.log(
        "Fetching offer letter count for month-year:",
        selectMonthOffer
      );

      // Make the API request
      const response = await axios.get(
        `${apiURL}DashboardRouter/GetOfferLetterSentCount`,
        {
          params: {
            request_month_year: selectMonthOffer,
            offer_status: selectedOfferStatus,
          },
          headers: apiHeaderJSON,
        }
      );

      const data = response.data;
      console.log("offer letter data ", data);
      // Handle success
      if (data.success) {
        console.log("data.data", data.data);
        const offerCount = data.data.offer_letter_count || 0; // Default to 0 if count is missing
        console.log("Offer Letter Count:", offerCount);
        setOfferLetterCount(offerCount);

        console.log("OfferLetterCount", offerCount);

        // Update chart options
        setChartOptions({
          labels: offerStatusOptions || ["No Data"], // Default label if options are missing
          series: offerCount ? [offerCount] : [0], // Default series if no count
        });
      } else {
        console.error(
          "Failed to fetch offer letter count. Message:",
          data.message || "No additional error message provided by server."
        );
      }
    } catch (error) {
      // Improved error handling
      console.error(
        "Error fetching offer letter count:",
        error.message || error
      );
    } finally {
      // Reset loading state after fetching data
    }
  };

  const getAppointmentLetter = (event, status) => {
    const selectMonthAppointment = event;
    const selectedOfferStatus = status;
    setselectMonthAppointment(selectMonthAppointment);
    const headers = apiHeaderJSON;
    if (selectMonthAppointment) {
      console.log(
        "Fetching appointment letter count for month-year:",
        selectMonthAppointment
      );
      axios
        .get(`${apiURL}DashboardRouter/GetAppointmentLetterSentCount`, {
          params: {
            request_month_year: selectMonthAppointment,
            offer_status: selectedOfferStatus,
          },
          headers,
        })
        .then((response) => {
          console.log("AppointmentLetterCount:", response);

          const data = response.data;

          if (data.success) {
            console.log(
              "AppointmentLetterCount:",
              data.data.appointment_letter_count
            );
            setappointmentLetterCount(data.data.appointment_letter_count);
          } else {
            console.error(
              "Failed to fetch appointment letter count. Message:",
              data.message
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching appointments letter count:", error);
        });
    }
  };

  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })

      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);
          setSelectedMonthYear(
            Array.isArray(data.filterData) &&
              data.filterData.length > 0 &&
              data.filterData[0]?.value
          );
          if (Array.isArray(data.filterData) && data.filterData.length > 0) {
            getAppointmentLetter(
              data.filterData[0]?.value,
              selectedOfferStatus
            );
            getOfferLetter(data.filterData[0]?.value, selectedOfferStatus);
            getJoinCountMonthWise(
              data.filterData[0]?.value,
              selectedOfferStatus
            );
          }
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

  // const getJoinCountMonthWise = async (event) => {
  //   const selectMonthJoin = event;
  //   setSelectMonthJoin(selectMonthJoin);

  //   if (!selectMonthJoin) {
  //     console.warn("No month selected for fetching joining count.");
  //     return;
  //   }

  //   console.log("Fetching joining count for month-year:", selectMonthJoin);

  //   const headers = apiHeaderJSON;

  //   try {
  //     const response = await axios.get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
  //       params: { request_month_year: selectMonthJoin },
  //       headers,
  //     });

  //     const data = response.data;

  //     if (data.success) {
  //       console.log("Joining Count Response:", data);

  //       const joiningCount = Array.isArray(data.data) ? data.data : []; // Ensure it's an array
  //       console.log("joindata",data.data )

  //       const processedJoiningCount = joiningCount.map((join) => data.data.join.joinie_count || 0);

  //       setJoiningData(processedJoiningCount);

  //       console.log("Processed Joining Count:", processedJoiningCount);
  //     } else {
  //       console.error("Failed to fetch joining count. Message:", data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching joining count:", error);
  //   }
  // };

  //   const getJoinCountMonthWise = (event) => {
  //     const selectMonthJoin = event;
  //     setSelectMonthJoin(selectMonthJoin);
  //     const headers = apiHeaderJSON;
  //     if (setSelectMonthJoin) {
  //       console.log(
  //         "Fetching joining count for month-year:",
  //         selectMonthJoin
  //       );
  //       axios
  //         .get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
  //           params: {
  //             request_month_year: selectMonthJoin,
  //           },
  //           headers,
  //         })
  //         .then((response) => {
  //           console.log("joiningCount:", response);

  //           const data = response.data;
  // const joindata=data.data.joinie_count;
  //           if (data.success) {
  //             console.log(
  //               "joiningCountData:",
  //               joindata
  //             );
  //             setJoiningData(data.data.joinie_count);
  //             console.log("data.data.joinie_count",data.data.joinie_count)
  //           } else {
  //             console.error(
  //               "Failed to fetch joining count. Message:",
  //               data.message
  //             );
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("Error fetchingjoining letter count:", error);
  //         });
  //     }
  //   };

  const getJoinCountMonthWise = (event) => {
    const selectMonthJoin = event;
    setSelectMonthJoin(selectMonthJoin);
    const headers = apiHeaderJSON;

    if (selectMonthJoin) {
      console.log("Fetching joining count for month-year:", selectMonthJoin);

      axios
        .get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
          params: { request_month_year: selectMonthJoin },
          headers,
        })
        .then((response) => {
          console.log("joiningCount:", response.data);
          const joindata = response.data;

          if (joindata.success) {
            console.log("joiningCountData:", joindata.data.joinie_count);
            setJoiningData(joindata.data);
          } else {
            console.error(
              "Failed to fetch joining count. Message:",
              joindata.message
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching joining letter count:", error);
        });
    }
  };

  return (
    <div className="card p-2">
      <div className="">
        <div className="row col-md-12 mb-3">
          <div className="col-md-3">
            <div>
              <label htmlFor="month_year" className="form-label">
                Month Year:
              </label>
              <Select
                id="month_year"
                name="month_year"
                value={
                  selectedMonthYear
                    ? monthYearOptions.find(
                        (option) => option.value === selectedMonthYear
                      )
                    : monthYearOptions[0]
                }
                onChange={(selectedOption) =>
                  handleSelectChange("month_year", selectedOption)
                }
                options={monthYearOptions}
                placeholder={
                  selectedMonthYear
                    ? monthYearOptions.find(
                        (option) => option.value === selectedMonthYear
                      )?.label
                    : monthYearOptions[0]?.label || "Select Month-Year"
                }
              />
            </div>
          </div>
          {/* Second column: Offer Status */}
          <div className="col-md-3">
            <div>
              <label htmlFor="offer_status" className="form-label">
                Status:
              </label>
              <Select
                id="offer_status"
                name="offer_status"
                value={
                  selectedOfferStatus
                    ? offerStatusOptions.find(
                        (option) => option.value === selectedOfferStatus
                      )
                    : null
                }
                onChange={(selectedOption) =>
                  handleSelectChange("offer_status", selectedOption)
                }
                options={offerStatusOptions}
                placeholder="Select Offer Status"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex gap-4">
        <div className="col-xl-3">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-success-subtle rounded-2 fs-2">
                    <i className="bx bx-calendar-check text-primary" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-medium text-muted mb-3">
                    New Joinee Count
                  </p>
                  <div className="d-flex align-items-center mb-3">
                    <h4 className="flex-grow-1 mb-0">
                      <span className="counter-value" data-target={0}>
                        {joiningData.joinie_count || 0}
                      </span>
                    </h4>
                    {/* <span className="badge bg-success-subtle text-success fs-12">
                  <i className="ri-arrow-up-s-line fs-13 align-middle me-1" />
                  3.58 %
                </span> */}
                  </div>
                  <p className="text-muted mb-0">Monthly New Joinee Count</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="card card-animate">
            <div className="card-p2">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-success-subtle text-success rounded-2 fs-2">
                      <i className="bx bx-envelope text-success" />
                    </span>
                  </div>
                  <div className="flex-grow-1 overflow-hidden ms-3">
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                      Offer Letter
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                          {offerLetterCount}
                        </span>
                      </h4>
                      {/* <span className="badge bg-danger-subtle text-danger fs-12">
                  <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                  5.35 %
                </span> */}
                    </div>
                    <p className="text-muted text-truncate mb-0">
                      Monthly{" "}
                      {`${
                        offerStatusOptions.find(
                          (val) => val.value == selectedOfferStatus
                        ).label
                      }`}{" "}
                      Offer Letter
                    </p>
                  </div>
                </div>
              </div>

              {/* end card body */}
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-primary-subtle text-primary rounded-2 fs-2">
                    <i className="bx bx-file text-primary" />
                  </span>
                </div>
                <div className="flex-grow-1 overflow-hidden ms-3">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                    Appointment Letter
                  </p>
                  <div className="d-flex align-items-center mb-3">
                    <h4 className="flex-grow-1 mb-0">
                      <span className="counter-value" data-target={0}>
                        {appointmentLetterCount}
                      </span>
                    </h4>
                    {/* <span className="badge bg-danger-subtle text-danger fs-12">
                  <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                  5.35 %
                </span> */}
                  </div>
                  <p className="text-muted text-truncate mb-0">
                    Monthly{" "}
                    {`${
                      offerStatusOptions.find(
                        (val) => val.value == selectedOfferStatus
                      ).label
                    }`}{" "}
                    Appointment Letter
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="col-xl-3">
             <ApexCharts
  options={{
    chart: {
      type: 'bar',
      height: '50vh',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    xaxis: {
      categories: offerStatusOptions.map(option => option.label), // Labels for x-axis
      title: {
        text: 'Offer Status', // Label for x-axis
      },
    },
    yaxis: {
      title: {
        text: 'Count', // Label for y-axis
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} Offer Letters`, // Show count in the tooltip
      },
    },
  }}
  series={[
    {
      name: 'Offer Letters', // Name for the bar chart
      data: chartData, // Data corresponding to each offer status
    },
  ]}
/> 
</div> */}
    </div>
  );
};

export default Onboarding;
